// extracted by css-extract-rspack-plugin
export default {"tooltip":"tooltip-C6qj5s","tooltipContent":"tooltipContent-lMAYdL","menuContainer":"menuContainer-TylimA","menuButton":"menuButton-xS41ad"};